export default [
  "/signin",
  "/signout",
  "/auth/forgot-password",
  "/reset-password",
  "/auth/forgot-password-success",
  "/verify",
];
